import { Warehouse } from '../../interfaces/Warehouse'
import {
  GET_WAREHOUSES_EXITO,
  GET_WAREHOUSES
} from '../types/warehouseActionsTypes'

export type WarehouseAction = WarehousesAction | WarehousesActionAsync

// Esto va a REDUX
export interface WarehousesAction {
  type: typeof GET_WAREHOUSES_EXITO
  warehouses: Warehouse[] | undefined
  error: string | undefined
}

export const getWarehousesAction = (
  warehouses?: Warehouse[],
  error?: string
): WarehousesAction => {
  return {
    type: GET_WAREHOUSES_EXITO,
    warehouses: warehouses,
    error
  }
}

// Esto va a SAGA
export interface WarehousesActionAsync {
  type: typeof GET_WAREHOUSES
}

export const getWarehousesActionAsync = (): WarehousesActionAsync => {
  return {
    type: GET_WAREHOUSES
  }
}
